module.exports = __webpack_public_path__ + "static/media/patient-story-avatar-larry.4bddb903.svg";